import type {
  EvidenceLine,
  EvidenceMark,
} from "@/lib/attributeReview/evidenceLines";

const MARK: Record<EvidenceMark, { glyph: string; cls: string }> = {
  ok: { glyph: "✓", cls: "text-emerald-600 dark:text-emerald-300" },
  warn: { glyph: "!", cls: "text-amber-700 dark:text-amber-300" },
  info: { glyph: "i", cls: "text-indigo-600 dark:text-indigo-300" },
};

export function EvidenceList({ lines }: { lines: EvidenceLine[] }) {
  if (lines.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1.5">
      {lines.map((line) => (
        <li
          key={line.text}
          className="grid grid-cols-[16px_minmax(0,1fr)] gap-2 text-[13px] leading-normal text-slate-800 dark:text-slate-200"
        >
          <span aria-hidden className={`font-bold ${MARK[line.mark].cls}`}>
            {MARK[line.mark].glyph}
          </span>
          <span>{line.text}</span>
        </li>
      ))}
    </ul>
  );
}
